// src/pages/driver/driverTimesheet/helpers.js — pure date/time/formatting helpers and shared
// style constant used by DriverTimesheet. No React state.

export const TIMEZONE = "Australia/Melbourne";

export const inputCls =
  "w-full rounded-xl border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm focus:border-emerald-400 focus:outline-none focus:ring-4 focus:ring-emerald-100 disabled:bg-gray-100 disabled:text-gray-500";

export const emptyDay = (date) => ({
  date,
  startTime: "",
  finishTime: "",
  breakMinutes: "30",
  secondStartTime: "",
  secondFinishTime: "",
  secondBreakMinutes: "",
  notes: "",
});

export const toLocalDateString = (date) =>
  date.toLocaleDateString("en-CA", { timeZone: TIMEZONE });

export const getMonday = (dateValue = new Date()) => {
  const date = new Date(dateValue);
  date.setHours(0, 0, 0, 0);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setDate(date.getDate() + diff);
  return date;
};

export const addDays = (date, amount) => {
  const next = new Date(date);
  next.setDate(next.getDate() + amount);
  return next;
};

export const formatDisplayDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(`${dateString}T00:00:00`);
  return date.toLocaleDateString("en-AU", {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });
};

export const formatTimestamp = (value) => {
  if (!value) return "";

  const date =
    typeof value?.toDate === "function"
      ? value.toDate()
      : typeof value === "number"
        ? new Date(value)
        : value?.seconds
          ? new Date(value.seconds * 1000)
          : new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-AU", {
    timeZone: TIMEZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getLeaveSubmittedText = (item) =>
  item.submittedAtText || formatTimestamp(item.submittedAt || item.createdAt);

export const minutesBetween = (start, finish) => {
  if (!start || !finish) return 0;
  const [sh, sm] = start.split(":").map(Number);
  const [fh, fm] = finish.split(":").map(Number);

  if ([sh, sm, fh, fm].some((value) => Number.isNaN(value))) return 0;

  const startMinutes = sh * 60 + sm;
  const finishMinutes = fh * 60 + fm;
  const diff =
    finishMinutes >= startMinutes
      ? finishMinutes - startMinutes
      : finishMinutes + 24 * 60 - startMinutes;
  return Math.max(diff, 0);
};

export const getShiftPaidMinutes = (start, finish, breakMinutes = 0) => {
  if (!start && !finish) return 0;
  const workedMinutes = minutesBetween(start, finish);
  return Math.max(workedMinutes - Number(breakMinutes || 0), 0);
};

export const formatHours = (hours) => Number(hours || 0).toFixed(2);

export const normalizeCompanyIds = (profile = {}) => {
  const ids = Array.isArray(profile.companyIds) ? profile.companyIds : [];
  return profile.companyId && !ids.includes(profile.companyId)
    ? [...ids, profile.companyId]
    : ids;
};

export const statusBadgeClass = (status) => {
  const clean = String(status || "draft").toLowerCase();
  if (clean === "approved") return "border-emerald-200 bg-emerald-50 text-emerald-700";
  if (clean === "rejected") return "border-red-200 bg-red-50 text-red-700";
  if (clean === "submitted" || clean === "pending") return "border-amber-200 bg-amber-50 text-amber-700";
  return "border-gray-200 bg-gray-50 text-gray-700";
};
